import validate from "/opt/atlassian/pipelines/agent/build/clients/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_200dbe9c4e635145fe987c6cb6f6705a/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45init_45global from "/opt/atlassian/pipelines/agent/build/clients/main/app/middleware/01.init.global.ts";
import _02_45auth_45global from "/opt/atlassian/pipelines/agent/build/clients/main/app/middleware/02.auth.global.ts";
import _03_45onboarding_45global from "/opt/atlassian/pipelines/agent/build/clients/main/app/middleware/03.onboarding.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/clients/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_200dbe9c4e635145fe987c6cb6f6705a/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45init_45global,
  _02_45auth_45global,
  _03_45onboarding_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}